import configInit from './init'

window.AppConfig = {
  subDomain: configInit.subDomain,
  webBaseUrl:'',
  baseApiUrl:'https://dikaragunaraksa.xtend.my.id/',
  apiUrl:'https://dikaragunaraksa.xtend.my.id/api/v1/',
  webSocketUrl:'',
  clientId:'iqs-web-admin',
  clientSecret:'d979e29f23f',
  googleApiKey:'AIzaSyBT8lAviOKfIVyNFtXnxi_KVjjiQOmt7w8',
  fbase: {
    initializeConfig: {
      apiKey:'AIzaSyDRs3Tc1Lzv1IS7Kl8SF_poirne3oagCX0',
      authDomain:'xtend-erp-dev.firebaseapp.com',
      databaseURL:'https://xtend-erp-dev.firebaseio.com',
      projectId:'xtend-erp-dev',
      storageBucket:'xtend-erp-dev.appspot.com',
      messagingSenderId:'',
      appId:'1:20308770906:web:c5cd7925c832851961d863',
      measurementId:'G-CWC12BWC2T'
    },
    vapidKey:'BGQ8Sdt9CNKSGK_K7UZ1xiy3TIsMDCHQpM7iDloFUA_jglL11IFkeVTD8Hsd-b-gYi6f1cC-ZzquOdJAcz6i8R4'
  },
  IntervalRefreshData: 120000,
  IntervalRefreshDataDashboard: 300000,
  dateFormat: 'DD-MM-YYYY hh:mm:ss A',
  shortDateFormat: 'DD-MM-YYYY'
}
